import PhoneInput from './PhoneInput';
import { getPhoneNumberParams, phoneNumberValidation, formatPhoneNumberIntl } from 'utils/phone';

import './styles.css';

export { getPhoneNumberParams, phoneNumberValidation, formatPhoneNumberIntl };

export default PhoneInput;
